var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.questions)?_c('div',{staticClass:"iaelements",attrs:{"id":_vm.uid}},[_vm._v("\n  "+_vm._s(_vm.template)+"\n")]):_c('div',[_vm._v("No questions to answer")])}
var staticRenderFns = []

export { render, staticRenderFns }